export default __webpack_public_path__ + "static/media/productHoneywell.213bc481.jpg";